'use client';

import { usePathname } from 'next/navigation';

import { getUsernameEmailSafetyPromptStatus } from './helpers/getUsernameEmailSafetyPromptStatus';
import { isExcludedRoute } from './helpers/isExcludedRoute';
import { isUsernameSimilarToEmail } from './helpers/isUsernameSimilarToEmail';

import { VARIANT_IDENTIFIER } from '@/modules/experiments/config';
import { useExperiments } from '@/modules/experiments/useExperiments';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

export function useUsernameEmailSafetyEligibility(): boolean {
  const pathname = usePathname();
  const [, user] = useCurrentUser();
  const { web_username_change_prompt } = useExperiments([
    'web_username_change_prompt',
  ]);

  if (web_username_change_prompt !== VARIANT_IDENTIFIER) {
    return false;
  }

  if (!user?.id || !user?.username || !user?.email) {
    return false;
  }

  if (isExcludedRoute(pathname)) {
    return false;
  }

  if (!getUsernameEmailSafetyPromptStatus(user.id)) {
    return false;
  }

  return isUsernameSimilarToEmail(user.username, user.email);
}
